<template>
  <div class="building-construction-page">
    <header class="hero-section">
      <div class="hero-text">
        <h1>Building & Construction Services</h1>
        <p class="hero-desc-main">
          At Oztopteam, we take pride in delivering exceptional building and construction services, tailored to meet the unique needs of each client. With our expert team and innovative approach, we bring your construction vision to life with precision and care.
        </p>
      </div>
    </header>

    <section class="service-overview fade-in-section">
      <div class="service-info">
        <h2>Our Expertise</h2>
        <p>
          We specialize in residential, commercial, and industrial construction projects. From ground-breaking to finishing touches, we are dedicated to quality, safety, and customer satisfaction. Whether it’s a new building or renovation, Oztopteam guarantees professional service from start to finish.
        </p>
      </div>
      <div class="service-img">
        <img src="https://www.shutterstock.com/image-vector/construction-site-lots-tower-cranes-600nw-1676223703.jpg" loading="eager" alt="Construction Site" class="construction-img">
      </div>
    </section>

    <div class="stats-section fade-in-section">
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.projects }}+</div>
        <div class="stats-sub-heading">Projects Completed</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.years }} Years</div>
        <div class="stats-sub-heading">In the Construction Industry</div>
      </div>
      <div class="stats-item">
        <div class="stats-heading">{{ animatedNumbers.rating }}<span class="star-rating">✭</span></div>
        <div class="stats-sub-heading">Client Satisfaction</div>
      </div>
    </div>

    <section class="services-section fade-in-section">
      <h2>Our Construction Services</h2>
      <div class="service-cards">
        <div class="service-card">
          <h3>Residential Construction</h3>
          <p>Custom-designed homes built with top-tier materials, ensuring quality and durability.</p>
        </div>
        <div class="service-card">
          <h3>Commercial Construction</h3>
          <p>From office spaces to retail establishments, we handle large-scale commercial projects efficiently.</p>
        </div>
        <div class="service-card">
          <h3>Renovations</h3>
          <p>Revitalize your property with our expert renovation services, ensuring enhanced functionality and aesthetics.</p>
        </div>
      </div>
    </section>

    <footer class="footer">
      <p>&copy; 2025 Oztopteam. All Rights Reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BuildingConstruction',
  data() {
    return {
      animatedNumbers: {
        projects: 0,
        years: 0,
        rating: 0,
      }
    };
  },
  mounted() {
    this.animateNumber('projects', 150, 2000);
    this.animateNumber('years', 15, 2500);
    this.animateNumber('rating', 5, 1000);
    this.observeSections();
  },
  methods: {
    animateNumber(ref, target, duration) {
      let start = this.animatedNumbers[ref];
      let stepTime = 16; 
      let step = (target - start) / (duration / stepTime);

      const updateNumber = () => {
        if (start < target) {
          start += step;
          this.animatedNumbers[ref] = Math.floor(start);
          requestAnimationFrame(updateNumber);
        } else {
          this.animatedNumbers[ref] = target;
        }
      };

      requestAnimationFrame(updateNumber);
    },
    observeSections() {
      const sections = document.querySelectorAll('.fade-in-section');

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      sections.forEach(section => observer.observe(section));
    }
  }
};
</script>

<style scoped>
/* Initial state for fade-in animation */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* When element becomes active (in view) */
.fade-in-section.active {
  opacity: 1;
  transform: translateY(0);
}

/* Hero Section */
.hero-section {
  background-color: #283E4A;
  padding: 60px 20px;
  text-align: center;
}

.hero-text h1 {
  font-size: 2.5rem;
  color: #FFF;
  margin-bottom: 20px;
  opacity: 0;
  animation: fadeInUp 1s 0.3s ease-out forwards;
}

.hero-desc-main {
  font-size: 1.2rem;
  color: #DDD;
  margin-bottom: 30px;
  opacity: 0;
  animation: fadeInUp 1s 0.6s ease-out forwards;
}

/* Construction Image */
.construction-img {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 10px;
  opacity: 0;
  animation: fadeInUp 1s 1s ease-out forwards;
}

/* Stats Section */
.stats-section {
  display: flex;
  justify-content: space-around;
  background-color: #2b2c38;
  padding: 40px 20px;
  color: white;
  text-align: center;
}

.stats-item {
  flex: 1;
  margin: 0 20px;
}

.stats-heading {
  font-size: 2rem;
  font-weight: bold;
}

.stats-sub-heading {
  font-size: 1rem;
  color: #d0d4c3;
}

/* Services Section */
.services-section {
  background-color: #f9f9f9;
  padding: 40px 20px;
  text-align: center;
}

.service-cards {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.service-card {
  background: #FFF;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
}

.service-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 10px;
}

.service-card p {
  color: #777;
  font-size: 1rem;
}

/* Footer */
.footer {
  text-align: center;
  padding: 20px;
  background-color: #283E4A;
  color: white;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.service-info{
  padding: 8%;
    color: wheat;
}
</style>
